import { ArrowDropDownOutlined, ArrowDropUpOutlined } from '@mui/icons-material';
import { FormControl, IconButton, TextField } from '@mui/material';
import { type FC, useRef, useState } from 'react';

import { BeginFilterPopper } from './BeginFilterPopper';
import { predefinedOptions, useBeginFilterParams } from './hooks/useBeginFilterParams';

type BeginFilterProps = {
  readonly inDrawer?: boolean;
};

export const BeginFilter: FC<BeginFilterProps> = ({ inDrawer }: BeginFilterProps) => {
  const [open, setOpen] = useState(false);
  const [{ option, startDate, endDate }, { setOption, setDates }] = useBeginFilterParams();

  const inputRef = useRef<HTMLDivElement>(null);

  return (
    <FormControl sx={{ width: inDrawer ? '100%' : '12rem' }}>
      <TextField
        ref={inputRef}
        size="small"
        onClick={() => setOpen(true)}
        value={predefinedOptions.find((o) => o.value === option)?.label}
        label="Veranstaltungsbeginn"
        slotProps={{
          inputLabel: { shrink: true },
          input: {
            endAdornment: (
              <IconButton size="small">{open ? <ArrowDropUpOutlined /> : <ArrowDropDownOutlined />}</IconButton>
            ),
          },
        }}
      ></TextField>
      {open && (
        <BeginFilterPopper
          // eslint-disable-next-line react-hooks/refs -- TODO: fix this! (disabled initially when enabling react-hooks rules)
          anchorEl={inputRef.current}
          setOpen={setOpen}
          initialStartDate={startDate}
          initialEndDate={endDate}
          option={option}
          setOption={setOption}
          setDates={setDates}
        />
      )}
    </FormControl>
  );
};
